import auth0 from 'auth0-js'

export default ({ Vue }) => {
  Vue.prototype.$auth0 = auth0
}
